import Vue from 'vue'

export default Vue.extend({
  methods: {
    leaveCast () {
      this.$confirm(
        'Do you want to leave the page?',
        'Leaving the page will disconnect any camera/mic connections you have open',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }
      ).then(() => {
        const route = this.$router.resolve({ name: 'events' })
        window.location.href = route.href
      }).catch(() => {
        //
      })
    }
  }
})
